import { BuildType } from '@/services/ApiService.ts';
import {
    AssessmentEngineSubscriptionModel,
    AssessmentInstanceModel,
    AssessmentLiteModel,
    AssessmentResponseRequestModel,
    AssessmentResponseUpdateRequestModel,
    AssessmentResultResponseModel,
    RecommendedCategoryModel,
    UserSubscriptionResultModel,
} from '@/apiTypes/AssessmentTypes.ts';
import { RecommendedOccupationModel } from '@/apiTypes/OccupationTypes.ts';

export const assessmentApiEndpoints = (builder: BuildType) => ({
    getSubscriptions: builder.query<AssessmentEngineSubscriptionModel[], void>({
        query: () => '/assessment/subscriptions',
    }),
    getAssessmentsByUser: builder.query<AssessmentLiteModel[], string>({
        query: id => `/assessment/user/${id}`,
        providesTags: ['Assessments'],
    }),
    getAssessmentById: builder.query<AssessmentInstanceModel, string>({
        query: id => `/assessment/${id}`,
        providesTags: ['Assessments'],
    }),
    startAssessment: builder.mutation<AssessmentInstanceModel, { subscriptionId: string; userId: string }>({
        query: body => ({
            url: '/assessment/start-assessment',
            method: 'POST',
            body,
        }),
        invalidatesTags: ['Assessments'],
    }),
    submitAssessmentResponse: builder.mutation<AssessmentInstanceModel, AssessmentResponseRequestModel>({
        query: body => ({
            url: '/assessment/response',
            method: 'POST',
            body,
        }),
        invalidatesTags: ['Assessments'],
    }),
    updateAssessmentResponse: builder.mutation<AssessmentInstanceModel, AssessmentResponseUpdateRequestModel>({
        query: body => ({
            url: '/assessment/response',
            method: 'PUT',
            body,
        }),
        invalidatesTags: ['Assessments'],
    }),
    scoreAssessment: builder.mutation<AssessmentResultResponseModel, string>({
        query: assessmentInstanceId => ({
            url: `/assessment/score/${assessmentInstanceId}`,
            method: 'POST',
        }),
        // Scoring can flip the referral program's assessment gate (`status.canJoin`).
        invalidatesTags: ['Assessments', 'ReferralProgram'],
    }),
    getAssessmentResult: builder.query<AssessmentResultResponseModel, string>({
        query: assessmentInstanceId => ({
            url: `/assessment/result/${assessmentInstanceId}`,
            method: 'GET',
        }),
    }),
    getRecommendedOccupations: builder.query<{ recommendedOccupations: RecommendedOccupationModel[]; onetIds: string[] }, string>({
        query: assessmentInstanceId => ({
            url: `/assessment/recommended/occupations/${assessmentInstanceId}`,
            method: 'GET',
        }),
    }),
    getRecommendedOccupationsByUser: builder.query<RecommendedOccupationModel[], string>({
        query: userId => ({
            url: `/assessment/recommended/occupations/user/${userId}`,
            method: 'GET',
        }),
    }),
    getUserSubscriptionResults: builder.query<UserSubscriptionResultModel[], string>({
        query: userId => ({
            url: `/assessment/user-subscription-results/${userId}`,
            method: 'GET',
        }),
        providesTags: ['Assessments'],
    }),
    getRecommendedCategoriesByUser: builder.query<RecommendedCategoryModel[], string>({
        query: userId => ({
            url: `/assessment/recommended/categories/user/${userId}`,
            method: 'GET',
        }),
    }),
});
